import React, { useState, useEffect, useContext, createContext } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
// contexts
import { useAuth } from './Auth';
import { SettingsContext } from './Settings';
// services
import { listTickets } from '../services/Ticket';
import { listSections } from '../services/Section';
import { listAdminInventory } from '../services/Inventory';

export const TicketsContext = createContext();

TicketsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default function TicketsProvider({ children }) {
  const [searchParams] = useSearchParams();
  const [sections, setSections] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [inventory, setInventory] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const { authUser } = useAuth();
  const { authSettings } = useContext(SettingsContext);

  useEffect(() => {
    const fetchData = async (eventId) => {
      try {
        const idToken = await authUser.getIdToken();
        const headers = {
          Authorization: `Bearer ${idToken}`,
          'Account-Key': authSettings.server.path
        };

        const inventory = await listAdminInventory({ headers, eventId });
        setInventory(inventory);

        const tickets = await listTickets({ eventId });
        if (tickets.length) {
          const sectionTickets = tickets.reduce((list, item) => {
            if (!list[item.section._id]) {
              list[item.section._id] = [item];
            } else {
              list[item.section._id].push(item);
            }

            return list;
          }, []);

          setTickets(sectionTickets);
        }
        const sections = await listSections({ eventId });
        if (sections.length) {
          setSections(sections);
        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        alert('An error occurred! Please, refresh the page and try again.');
      }
    };

    const eventId = searchParams.get('eventId');
    if (eventId) {
      fetchData(eventId);
    } else {
      setIsLoading(false);
    }
  }, [searchParams, authUser, authSettings, setTickets, setSections]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={3}>
        <CircularProgress color="inherit" />
      </Box>
    );
  }

  return (
    <TicketsContext.Provider value={{ sections, setSections, tickets, setTickets, inventory }}>
      {!isLoading && children}
    </TicketsContext.Provider>
  );
}
